var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirFreightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1019 47.507L20.9719 35.664L49.1499 21.354C50.1149 20.863 50.9909 22.146 50.1839 22.867L33.7499 39L22.7459 48.261C22.0989 48.805 21.1109 48.352 21.1019 47.507Z",
    fill: "#FF9DA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32811 27.315L20.9721 35.665L48.3911 22.113C48.7501 21.947 49.0301 22.454 48.6991 22.67L26.0301 37.16C25.3861 37.572 25.4231 38.525 26.0981 38.885L44.3271 48.605C44.6461 48.775 45.0421 48.639 45.1891 48.308L58.8901 17.482C59.3001 16.558 58.4981 15.556 57.5071 15.754L5.5011 26.155C4.9291 26.27 4.81411 27.038 5.32811 27.315Z",
    fill: "#FF3841"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirFreightIcon);
export default __webpack_public_path__ + "static/media/air-freight-icon.f4c9526d0e19eafb2a32a291501df698.svg";
export { ForwardRef as ReactComponent };